import { Component, Inject, Vue } from "vue-property-decorator";

// Types
import {
  IBillableEntitiesProvider,
  IBillableEntitiesProviderMethods
} from "@/models/providers/billableEntities";

@Component
export default class BillableEntitiesInjectorMixin extends Vue {
  // Inject - Billable entities provider data

  @Inject({ from: "billableEntitiesProvider" })
  public readonly $billableEntitiesData!: () => IBillableEntitiesProvider;

  public get billableEntitiesData() {
    return this.$billableEntitiesData();
  }

  // Inject - Billable entities provider Methods

  @Inject({ from: "billableEntitiesProviderMethods" })
  public readonly $billableEntitiesMethods!: IBillableEntitiesProviderMethods;
}
